import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

export const DEFAULT_SEDE = '/trabalhe-na-agsus/processos-seletivos';
export const DEFAULT_DSEI = '/trabalhe-na-agsus/saude-indigena';

const fromObjectBrowser = (value, fallback) => {
  const first = Array.isArray(value) ? value[0] : value;
  const id = first && (first['@id'] || first);
  return id ? flattenToAppURL(id) : fallback;
};

export const sourcesOf = (data) => [
  {
    key: 'sede',
    path: fromObjectBrowser(data.fonteSede, DEFAULT_SEDE),
    // dois níveis: os editais soltos na pasta e os de subpastas, como a de
    // vagas na Sede Administrativa, que com um nível ficavam fora da tabela
    depth: 2,
    // ProcessoSeletivo: o tipo próprio desde 11/2026; News Item: os editais migrados
    portalTypes: ['News Item', 'ProcessoSeletivo', 'Link'],
  },
  {
    key: 'dsei',
    path: fromObjectBrowser(data.fonteDsei, DEFAULT_DSEI),
    depth: 2,
    portalTypes: ['News Item', 'ProcessoSeletivo'],
  },
];

export const searchOptions = (source) => ({
  // o caminho vai na URL do searchContent (contexto do @search): via
  // path.query na raiz, o SSR interno não resolve (falta o prefixo físico)
  'path.depth': source.depth,
  portal_type: source.portalTypes,
  sort_on: 'effective',
  sort_order: 'descending',
  b_size: 300,
  metadata_fields: ['Subject', 'effective', 'modified'],
});

export default function getProcessSearchAsyncData({ dispatch, id, data }) {
  return sourcesOf(data).map((source) =>
    dispatch(
      searchContent(
        source.path,
        searchOptions(source),
        `agsusProcessSearch_${id}_${source.key}`,
      ),
    ),
  );
}
